import React from 'react';
import * as ReactRedux from 'react-redux';
import PropTypes from 'prop-types';
import { AnimationConstants } from 'Animation';
import withInit from 'WithInit';
import PreviewAnimationOverlay from './PreviewAnimationOverlay';


const ExportDocumentPreviewAnimation = props => (
  <React.Fragment>
    <PreviewAnimationOverlay
      progressBarAnimation={props.progressBarAnimation}
      src={props.src}
    />
    <iframe
      id="documentPreview"
      className="document-preview"
      src={props.src}
      scrolling="no"
    />
  </React.Fragment>
);

ExportDocumentPreviewAnimation.propTypes = {
  progressBarAnimation: PropTypes.shape({
    started: PropTypes.bool,
    finished: PropTypes.bool,
    step: PropTypes.number,
    stepInterval: PropTypes.number,
  }).isRequired,
  src: PropTypes.string.isRequired,
};

const mapStateToProps = ({ AnimationReducer }) => (
  {
    progressBarAnimation: AnimationReducer[AnimationConstants.PROGRESS_BAR_ANIMATION],
  }
);

const ExportDocumentPreviewAnimationWithRedux = ReactRedux.connect(
  mapStateToProps,
)(ExportDocumentPreviewAnimation);

export default withInit(ExportDocumentPreviewAnimationWithRedux, true);



// WEBPACK FOOTER //
// ./src-react/ExportDocumentPreviewAnimation/index.jsx